export default __webpack_public_path__ + "static/media/the_city_from_canary_wharf.e0fbb13e.jpg";